export default "__VITE_ASSET__fdf69a3d__"